import { render, staticRenderFns } from "./HistoryDoctorMasseuseAll.vue?vue&type=template&id=126e098c&scoped=true&"
import script from "./HistoryDoctorMasseuseAll.vue?vue&type=script&lang=js&"
export * from "./HistoryDoctorMasseuseAll.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDoctorMasseuseAll.vue?vue&type=style&index=0&id=126e098c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e098c",
  null
  
)

export default component.exports